import React from 'react'
import "./loader.scss";

export default function loader() {
  return (
    
    <div class="loader"></div>
  )
}
